<template>
<!-- 品类管理 -->
<section class="viewContainer">
  <el-row :span="24">
    <!-- 排版左 Tree树形控件 -->
    <el-col :span="6">
      <!-- 商品分类管理 -->
      <div class="main_container">
        <section class="model_section"> <p class="model_top_title">商品分类管理</p> </section>
        <p style="padding: 0 0 10px 10px" class="goodslist1">
          <el-button type="danger" @click="addOrEditClassification">新增分类</el-button>
          <el-button type="danger" @click="addOrEditClassification('editRow')">编辑分类</el-button>
        </p>
        <el-collapse-transition>
        <div style="padding:0px 12px">
          <el-tree :data="treeData" :props="defaultProps" accordion @node-click="handleNodeClick" class="lineheighttree"/>
        </div>
        </el-collapse-transition>
      </div>
    </el-col>
    <!-- 排版右 查询列表 -->
    <el-col :span="18">
      <!--列表-->
      <div class="main_container">
        <div class="model_section">
          <p class="model_top_title"><span style="color: #F56C6C">{{commodityParameters}}</span> 品类关联的品牌及商品参数</p>
        </div>
        <div style="margin:0 0 10px 20px;">
          <el-button type="danger" @click="addRelatedBrand()" v-if="endChildren">新增关联品牌</el-button>
          <el-button type="danger" @click="seeCategoryOperationRecord()">查看当前品类操作记录</el-button>
          <el-button type="danger" @click="endManageProductParameters()" v-if="endParameter">管理商品参数</el-button>
        </div>
        <!-- table 列表 -->
        <div class="table_container" style="padding: 0 10px;">
          <el-table :data="dataList" stripe border>
            <el-table-column label="序号" align="center">
              <template scope="scope">
                <span :title="scope.row.Id" :label="scope.row.Id">{{scope.row.Id}}</span>
              </template>
            </el-table-column>
            <el-table-column label="关联的品牌" align="center">
              <template scope="scope">
                <span :title="scope.row.Name" :label="scope.row.Name">{{scope.row.Name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="编辑" fixed="right" width="200" align="center">
              <template scope="scope">
                <span @click="deleteBrand(scope.row)" class="action_container">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
        </div>
      </div>
    </el-col>
  </el-row>
  <!-- 新增/编辑分类-弹框 -->
  <el-dialog title="品类管理" :center="true" class="add_order_cancle" width="30%" :visible.sync="isToExamine">
    <el-form>
      <el-form-item label="所属一级分类:" label-width="100px">
        <el-select @change="selectChanged" v-model="classAclassification" :disabled="classAdisabled" placeholder="请选择" style="width:80%" filterable>
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in classAclassificationArr"
            :key="index"/>
        </el-select>
      </el-form-item>
      <el-form-item label="分类名称:" label-width="100px">
        <el-input maxlength="20" v-model="brandName" placeholder="请输入分类名称 (20字以内)" style="width:80%"/>
      </el-form-item>
      <el-form-item v-if="showLogo" label="分类Logo:" label-width="100px">
        <el-upload class="avatar-uploader" action accept=".png, .jpg" :show-file-list="false"
          :before-upload="beforeAvatarUpload">
          <img v-if="Thumbnail" style="width:80px;height:80px" :src="Thumbnail" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div>
          <img src="../../assets/img/aicon15_09.jpg" alt style="display:inline-block"/>
          <span style="color: #888">尺寸必须为90px*36px，支持png、jpg格式</span>
        </div>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left:0;text-align:center">
      <button type="button" @click="isToExamine = false"
        class="el-button el-button--default cancle normal_btn">取消</button>
      <button type="button" @click="editSubmit()"
        class="el-button el-button--default search_btn normal_btn">保存</button>
    </div>
  </el-dialog>
  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="dialogTable" :before-close="cancelForm" :show-close= false>
    <template v-slot:title>
      <ul class="drawer_title">
        <li>{{record}}</li>
        <el-button type="danger" @click="cancelForm">关 闭</el-button>
      </ul>
    </template>
    <div class="drawer_div">
      <el-table ref="table" :data="gridData" height="600">
        <el-table-column property="OperationDes" label="操作类型" align="center"/>
        <el-table-column property="OperatorName" label="操作人" align="center"/>
        <el-table-column property="CTime" label="操作时间" align="center"/>
        <template slot="append">
          <div class="scrollingTips">
            <p v-if="loading">正在加载</p>
            <p v-if="noMore">没有更多了</p>
          </div>
        </template>
      </el-table>
    </div>
  </el-drawer>
  <!-- 新增关联品牌-弹框 -->
  <el-dialog title="关联品牌" :center="true" class="add_order_cancle" width="26%" :visible.sync="vRelatedBrands">
    <el-form>
      <el-form-item label="所属品牌:">
        <el-select v-model="modelBrandId" placeholder="请选择" style="width:66%" filterable>
          <el-option
            :label="item.Name"
            :value="item.Id"
            v-for="(item,index) in brandArr"
            :key="index"/>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left:0;text-align:center">
      <button type="button" @click="vRelatedBrands = false"
        class="el-button el-button--default cancle normal_btn">取消</button>
      <button type="button" @click="editBrand()"
        class="el-button el-button--default search_btn normal_btn">保存</button>
    </div>
  </el-dialog>
  <!-- 管理商品参数-弹框 -->
  <el-dialog title="管理商品参数" :center="true" width="35%" :visible.sync="vCommodityParameters">
    <div class="formLabel">
      <el-table :data="propTableData.col" border>
        <el-table-column label="序号" type="index" align="center" width="60"/>
        <el-table-column prop="Name" label="参数名称" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isSet">
              <el-input size="mini" v-model="scope.row.Name" maxlength="6"/>
            </span>
            <span v-else>{{ scope.row.Name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" width="170px">
          <template slot="header">
            <el-button size="mini" @click="handleAdd">新增</el-button>
          </template>
          <template slot-scope="scope">
            <template v-if="!scope.row.isSet">
              <el-button size="mini" style="margin: 6px 3px;"
                @click="valChange(scope.row)">编辑</el-button>
              <el-button size="mini" style="margin: 6px 3px;"
                @click="handleDelete(scope.row, scope.$index)">删除</el-button>
            </template>
            <template v-else>
              <el-button size="mini" style="margin: 6px 3px;"
              @click="paramSave(scope.row)">保存</el-button>
              <el-button size="mini" style="margin: 6px 3px;"
              @click="cancelAddOrEdit(scope.row)">取消</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹框按钮 确定/取消 -->
    <div class="footParameterPopup">
      <button type="button" @click="vCommodityParameters = false" class="el-button">取消</button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { UploadImgForServer } from '../../api/newOss';
import { getSelectGoodsTypeForTree, getSelectBrandByGoodsTypeId, getSelectBaseDataOpeationLog, getInsertGoodsType,
  getSelectBrandNotByGoodsTypeId, getInsertBrandAndTypeRelation, getDeleteBrandTypeRelation, getUpdateGoodsType,
  getGetGoodsParameterList, getAddGoodsParameters, getRemoveGoodsParameters, getUpdateGoodsParameters } from "../../api/api";
export default {
  mixins: [alertTrends],
  data() {
    return {
      treeDataArr: [], // 树形控件当前选中项
      dataId: "", // 树形控件选中id
      endChildren: true, // 新增关联品牌是否显示
      commodityParameters: "", // 二级品类关联的品牌及商品参数
      endParameter: true, // 管理商品参数按钮是否显示
      vCommodityParameters: false, // 管理商品参数
      propTableData: {
        status:'', // 状态: 编辑:edit, 新增:add, 默认: ''
        originName:'', // 原始参数名
        sel: null, // 选中行
        col: []
      },
      dialogTable: false, // 抽屉详情
      timer: null,
      vRelatedBrands: false, // 关联品牌弹框
      modelBrandId: "", // 品牌
      brandArr: [], // 品牌列表
      isToExamine: false, // 新增/编辑分类弹框
      showLogo: true, // 品牌Logo 默认为: true 显示状态
      classAclassification: "", // 所属一级分类
      brandName: "", // 分类名称
      Thumbnail: "", // 分类Logo
      classAclassificationArr: [], // 所属一级分类列表
      classAdisabled: false, // 所属一级分类是否置灰, 默认启用
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      record: "操作记录", // 操作记录
      goodsPageIndex: 1, // 抽屉详情页页码
      goodsPageSize: 50, // 抽屉详情页条数 默认50条
      gridData: [], // 操作记录列表
      loading: false, // 是否加载中
      noMore: false // 是否最后一页, 没有更多了
    }
  },
  methods: {
    // 初始化树列
    handleNodeClick(data) {
      this.treeDataArr = data;
      this.dataId = data.id;
      // console.log(data,'触发树控的时候');
      // console.log(data.id,'触发树控的当前id');
      if (data.children) {
        // console.log('有children')
        this.endChildren = false;
        this.endParameter = false;
        this.dataList = [];
      } else {
        // console.log('没有children')
        this.endChildren = true;
        this.endParameter = true;
        this.commodityParameters = this.treeDataArr.label;
        this.getDataAnalysis();
      }
      // if (data.children && data.children.length > 0) {
      //   console.log('有子节点')
      // } else {
      //   console.log('没有子节点')
      // }
    },
    // 初始化树形控件
    getTreeShape() {
      // 调用树形菜单接口
      getSelectGoodsTypeForTree().then(data => {
        let that = this
        let treeList = [];
        data.ResultObj.map(item => {
          let treeControlData = {id:item.Id,label:item.Name,children:[]}
            treeList.push(treeControlData)
            item.BaseDataModel_Nodes.map(tree => {
              treeControlData.children.push({parentId:item.Id, id:tree.Id, label:tree.Name, ImgUrl:tree.ImgUrl})
            })
        });
        that.treeData = treeList
        this.total = data.RowsCount;
      })
    },
    // 根据二级品类查询品类关联的品牌列表
    getDataAnalysis() {
      let addParams = {
        goodsTypeId: this.dataId, // 二级品类ID
        pageIndex: this.pageIndex,// 分页数据 当前页码
        pageSize: this.pageSize // 分页数据 每页显示条数
      };
      getSelectBrandByGoodsTypeId(addParams).then(data => {
        this.dataList = data.ResultObj;
        this.total = data.RowsCount;
      })
      .catch(err => {
        this.dataList = [];
        this.total = 0;
      });
    },
    // 新增分类 & 编辑分类
    addOrEditClassification(editRow) {
      // 如果就这个string属性就是编辑, 否则就不是
      if(editRow == "editRow") {
        if(this.dataId) {
          if (this.treeDataArr.children) {
            // console.log('有叶子结点')
            // console.log(this.treeDataArr,'当前选中的一级数据');
            this.classAclassification = 0 ? "无" : "无"
            this.brandName = this.treeDataArr.label
            this.classAdisabled = true; // 说明是一级, 设置禁用
            this.showLogo = false; // 品类Logo消失
          } else {
            // console.log('没有叶子结点')
            // console.log(this.treeDataArr,'当前选中的二级数据');
            // console.log(this.treeDataArr.parentId,'当前选中的子级的腹肌id');
            this.classAclassification = 0 ? "无" : this.treeDataArr.parentId
            this.brandName = this.treeDataArr.label
            this.Thumbnail = this.treeDataArr.ImgUrl
            this.classAdisabled = false; // 说明是二级, 解禁
            this.showLogo = true; // 品类Logo显示
            this.getPrimaryClassification();
          }
          this.isToExamine = true;
        } else {
          this.showAlert('请选择需要编辑的分类');
          return false
        }
      } else {
        // 否则就是新增
        this.dataId = "", // id置空
        this.isToExamine = true;
        this.classAdisabled = false; // 新增弹框初始化列表启用
        this.classAclassification = ""; // 新增弹框初始化列表置空
        this.brandName = "", // 新增弹框初始化分类名称置空
        this.Thumbnail = "", // 新增弹框初始化品类Logo置空
        this.showLogo = true; // 品类Logo显示
        this.getPrimaryClassification();
      }
    },
    // 获取所属一级分类列表数据
    getPrimaryClassification() {
      // 调用树列接口 取一级分类
      getSelectGoodsTypeForTree().then(data => {
        if (data.ResultCode == 1) {
          this.classAclassificationArr = data.ResultObj;
          // 判断不是编辑进来的才会 push 无
          if (!this.dataId) {
            this.classAclassificationArr.unshift({
              Id: 0,
              Name: "无"
            });
          }
        }
      })
    },
    // 所属一级分类 change 事件
    selectChanged(value) {
      this.classAclassification = value;
      // console.log(this.classAclassification,'选中当前的id')
      if (this.classAclassification == 0) {
        // console.log('选择的是无');
        this.showLogo = false; // 品类Logo消失
      } else {
        // console.log('选择了一级分类');
        this.showLogo = true; // 品类Logo显示
      }
    },
    // 保存 新增/编辑分类
    editSubmit() {
      if(this.classAclassification === "") {
        this.showAlert('请选择所属一级品类');
        return false
      }
      if(this.brandName == ""){
        this.showAlert('请输入分类名称');
        return false
      }
      if(!this.classAclassification === "") {
        if(this.Thumbnail == ""){
          this.showAlert('请上传品类Logo');
          return false
        }
      }
      // 判断是编辑还是新增, 如果有id就是编辑
      if (this.dataId) {
        // console.log('编辑-修改按钮')
        // console.log(this.treeDataArr,'保存时,传入什么数据');
        if(this.treeDataArr.children) {
          var loginParams = {
            operId: localStorage.Id, // 当前操作人id
            id: this.dataId, // 当前修改的品类ID
            parentId: 0, // 所属一级品类ID，如果当前品类为一级品类传0，否则必须选择所属一级分类
            name: this.brandName, // 分类名称
            imgUrl: this.Thumbnail // 品类Logo
          };
        } else {
          var loginParams = {
            operId: localStorage.Id, // 当前操作人id
            id: this.dataId, // 当前修改的品类ID
            parentId: this.treeDataArr.parentId, // 所属一级品类ID，如果当前品类为一级品类传0，否则必须选择所属一级分类
            name: this.brandName, // 分类名称
            imgUrl: this.Thumbnail // 品类Logo
          };
        }
        getUpdateGoodsType(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.showAlert('编辑分类修改成功', 'success');
            this.isToExamine = false;
            this.getTreeShape();
          }
        })
        .catch(err => {
          console.log(err);
        });
      } else {
        // console.log('新增-保存按钮')
        var loginParams = {
          operId: localStorage.Id, // 当前操作人id
          parentId: this.classAclassification, // 所属一级品类，如果当前品类为一级品类则没有所属一级品类传0，二级品类必须有所属一级品类
          name: this.brandName, // 分类名称
          imgUrl: this.Thumbnail // 品类Logo
        };
        getInsertGoodsType(loginParams).then(data => {
          if (data.ResultCode == 1) {
            data = data.ResultObj;
            this.showAlert('新增分类保存成功', 'success');
            this.isToExamine = false;
            this.getTreeShape();
          }
        })
        .catch(err => {
          console.log(err);
        });
      }
    },
    // 上传分类Logo方法及接口
    beforeAvatarUpload(file) {
      const isSize = new Promise(function(resolve, reject) {
        let width = 90;
        let height = 36;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          var that = this;
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function(e) {
            that.Thumbnail = e.target.result
            var obj = {
              base64Img:  e.target.result,
            };
            UploadImgForServer(obj).then(data => {
              if (data.ResultCode == 1) {
                that.Thumbnail = localStorage.BaseUrl+data.ResultObj
              }
            });
          };
          return file;
        },
        () => {
          this.showAlert('上传图片宽高尺寸应为90*36');
          return Promise.reject();
        }
      );
      return isSize;
    },
    // 点击触发新增关联品牌
    addRelatedBrand() {
      // 判断有没有二级品类
      if(!this.dataId){
        this.showAlert('请选择二级品类');
        return false
      }
      this.vRelatedBrands = true;
      this.getbrandarr();
    },
    // 管理商品参数
    endManageProductParameters() {
      // 判断有没有二级品类
      if(this.dataId){
        this.vCommodityParameters = true;
        this.getParameterList(); // 调取查询参数列表接口
      } else {
        this.showAlert('请选择二级品类');
        return false
      }
    },
    // 查询根据商品品类查询商品参数列表
    getParameterList() {
      let addParams = {
        goodsBrandTypeId: this.dataId // 必填。商品品类id
      };
      getGetGoodsParameterList(addParams).then(data => {
        let that = this
        that.propTableData.col = data.ResultObj || [];// 如果是空, 给个默认数据
        that.propTableData.col.map(i => {
          that.$set(i, 'isSet', false)
        })
      })
    },
    // 新增参数
    handleAdd() {
      // 如果正在修改已存在的标签
      if(this.propTableData.status == 'add'){
        return
      }
      if(this.propTableData.status == 'edit'){
        // 清理现场
        this.propTableData.sel.Name = this.propTableData.originName
        this.propTableData.sel.isSet = false
        this.propTableData.sel = null
        this.propTableData.originName = ''
      }
      let row = {
        Id:'',
        Name: '',
        isSet: true
      }
      this.propTableData.col.unshift(row)
      this.propTableData.sel = row
      this.propTableData.status = 'add'
    },
    // 编辑按钮
    valChange(row) {
      if(this.propTableData.status == 'add'){
          this.propTableData.col.shift()
          this.propTableData.sel = null
          this.propTableData.originName = ''
        }
      if(this.propTableData.status == 'edit'){
        // 清理现场
        this.propTableData.sel.Name = this.propTableData.originName
        this.propTableData.sel.isSet = false
        this.propTableData.sel = null
        this.propTableData.originName = ''
      }
      this.propTableData.sel = row
      this.propTableData.originName = row.Name
      row.isSet = true
      this.propTableData.status = 'edit'
    },
    // 保存按钮
    paramSave(row, index) {
      if (row.Name) { } else {
        this.showAlert('请输入参数名称');
        return
      }
      console.log('edit', this.propTableData)
      //点击修改，判断是否已经保存所有操作
      for (let i of this.propTableData.col) {
        if (i.isSet && i.id != row.id) {
          this.showAlert('修改');
          return false
        }
      }
      //保存已存在的标签
      if (row.Id) {
        console.log('this.propTableData.sel', this.propTableData.sel)
        const v = this.propTableData.sel // 取到编辑的数据
        // 必填项判断, 数据中参数名是否填写了
        let addParams = {
            Id: v.Id, // 必填。商品品类id
            Name:v.Name
          };
        getUpdateGoodsParameters(addParams).then(data => {
          let that = this
          if(data.ResultCode == 1){
            row.isSet = false
            this.propTableData.sel = null
            this.propTableData.originName = ''
            this.propTableData.status = ''
          }else if(data.ResultCode in {0:0,2:2}){
            this.showAlert(data.ResultMsg, 'error');
          }
        })
      }else{ // 新增标签
        const v = this.propTableData.sel // 取到编辑的数据
        // 必填项判断, 数据中参数名是否填写了
        let addParams = {
            goodsBrandTypeId: this.dataId, // 必填。商品品类id
            goodsParameters: v.Name
          };
        getAddGoodsParameters(addParams).then(data => {
          let that = this
          if(data.ResultCode == 1){
            this.propTableData.sel.isSet = false
            this.propTableData.sel = null
            this.propTableData.originName = ''
            this.propTableData.status = ''
          }else if(data.ResultCode in {0:0,2:2}){
            this.showAlert(data.ResultMsg, 'error');
          }
        })
      }
    },
    // 取消按钮
    cancelAddOrEdit(row) {
      if (row.Id) {
        row.isSet = false
        this.propTableData.sel = {}
        this.propTableData.originName = ''
      }else{
        this.propTableData.col.splice(0, 1)
        this.propTableData.sel = {}
      }
      this.propTableData.status = ''
    },
    // 删除按钮
    handleDelete(row, index) {
      console.log(row.Id);
      var obj = {
        goodsParameterIds: row.Id // 商品参数名称，以英文逗号分隔，参数示例：1,2,3,4	
      };
      getRemoveGoodsParameters(obj).then(data => {
        if(data.ResultCode == 1){
          this.propTableData.col.splice(index, 1)  // 从index位置开始 删除1 个元素
        }else if(data.ResultCode in {0:0,2:2}){
          this.showAlert(data.ResultMsg, 'error');
        }
      });
    },
    // 获取品牌列表接口
    getbrandarr() {
      this.modelBrandId = "";
      var obj = {
        goodsTypeId: this.dataId // 二级品类ID
      };
      getSelectBrandNotByGoodsTypeId(obj).then(data => {
        if (data.ResultCode == 1) {
          this.brandArr = data.ResultObj;
        }
      });
    },
    // 点击保存关联品牌
    editBrand() {
      if(this.modelBrandId == ""){
        this.showAlert('请选择关联品牌');
        return false
      }
      var obj = {
        operId: localStorage.Id, // 当前操作人
        brandId: this.modelBrandId, // 品牌ID
        goodsTypeId: this.dataId // 二级品类ID
      };
      getInsertBrandAndTypeRelation(obj).then(data => {
        if (data.ResultCode == 1) {
          data = data.ResultObj;
          this.showAlert('关联品牌保存成功', 'success');
          this.vRelatedBrands = false;
          this.getDataAnalysis();
        }
      });
    },
    // 点击操作记录
    seeCategoryOperationRecord() {
      this.record = "操作记录";
      if (this.dataId) {
        this.goodsPageIndex = 1;
        this.dialogTable = true;
        this.browseNumber() // 加载数据, 默认先加载50条
        // 监听表格dom对象的滚动事件
        this.$nextTick(() => {
          let dom = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
          dom.addEventListener('scroll', () => {
            let { scrollHeight, scrollTop, clientHeight } = dom
            const scrollDistance = scrollHeight - scrollTop - clientHeight
            if (scrollDistance <= 0 && this.loading !== true) {
              // 等于0证明已经到底，可以再次请求接口
              this.browseNumber() // 加载数据
            }
          })
        })
      } else {
        this.showAlert('请选择二级品类');
        return false
      }
    },
    // 操作记录+无限滚动
    browseNumber() {
      var that = this;
      if (that.goodsPageIndex < that.goodsPageSize) {
        let addParams = {
          baseDataId: that.dataId,
          baseDataType: 2,
          pageIndex: that.goodsPageIndex, // 当前页码
          pageSize: that.goodsPageSize // 条数，默认50条
        };
        getSelectBaseDataOpeationLog(addParams).then(data => {
          if (data.ResultCode == 1) {
            that.gridData = that.gridData.concat(data.ResultObj)
            that.goodsPageIndex++
            that.loading = false
          } else {
            that.noMore = true
            that.loading = false
          }
        })
      } else {
        that.noMore = true
        that.loading = false
      }
    },
    // 关闭抽屉弹框
    cancelForm() {
      this.gridData = [];
      this.dialogTable = false;
      clearTimeout(this.timer);
    },
    // 单条删除-列表数据
    deleteBrand(row){
      this.$swal({
      type:'warning',
      text: '重要信息，你确定要删除吗？',
      showCancelButton:true,
      reverseButtons: true, // 添加这一行来反转按钮顺序
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = {
            operId: localStorage.Id, // 当前操作人
            goodsTypeId: this.dataId, // 二级品类ID
            brandId: row.Id // 品牌ID
          }
          getDeleteBrandTypeRelation(obj).then(data=>{
            if(data.ResultCode == 1){
              this.showAlert('操作成功', 'success');
              this.getDataAnalysis();
            }
          })
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDataAnalysis();
    }
  },
  created() {
    let that = this;
    // 查询列表
    setTimeout(function() {
      that.getTreeShape();
    }, 200);
  }
}
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped>
.formLabel {
  width: 100%;
  height: 360px;
  margin-bottom: 40px;
  overflow: scroll;
}
.footParameterPopup {
  width: 100%;
  height: 66px;
  line-height: 66px;
  border-top: 1px solid #eee;
  text-align:center;
  position: absolute;
  bottom: 0;
  left: 0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  width: 80px;
  height: 80px;
  line-height: 80px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-left: 0px;
  margin-top: 0px;
}
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.scrollingTips {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// categoryManagement.vue?241806a8